import './AuthPhoto.scss';
import logo from '../../../../assets/img/training-center.png';

function AuthPhoto() {
    return (
        <div className="auth-img">
            <img src={logo} alt="register Background" />
        </div>
    )
}
export default AuthPhoto;